import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-alert-manager',
    templateUrl: './alert-manager.component.svg',
    styleUrls: ['./alert-manager.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertManagerComponent {}
